import { useQuery } from '@tanstack/react-query';
import { errorsApi, accountsApi } from '../api/client';
import { formatDate } from '../utils/formatTimestamp';
import styles from './Dashboard.module.css';

export function Dashboard() {
  const { data: errorStats } = useQuery({
    queryKey: ['error-stats'],
    queryFn: () => errorsApi.getStats(),
  });

  const { data: accountsData } = useQuery({
    queryKey: ['accounts', { limit: 5 }],
    queryFn: () => accountsApi.list({ limit: 5 }),
  });

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Dashboard</h1>

      <div className={styles.statsGrid}>
        <div className={styles.statCard}>
          <span className={styles.statLabel}>Total Accounts</span>
          <span className={styles.statValue}>
            {accountsData?.pagination.total ?? '-'}
          </span>
        </div>

        <div className={styles.statCard}>
          <span className={styles.statLabel}>Total Errors</span>
          <span className={styles.statValue}>
            {errorStats?.total ?? '-'}
          </span>
        </div>

        <div className={styles.statCard}>
          <span className={styles.statLabel}>Unresolved Errors</span>
          <span className={`${styles.statValue} ${styles.statWarning}`}>
            {errorStats?.unresolved ?? '-'}
          </span>
        </div>
      </div>

      <div className={styles.section}>
        <h2 className={styles.sectionTitle}>Recent Accounts</h2>
        <div className={styles.recentList}>
          {accountsData?.accounts.map((account) => (
            <div key={account.id} className={styles.recentItem}>
              <div className={styles.recentMain}>
                <span className={styles.recentName}>{account.username_display}</span>
                <span className={styles.recentEmail}>{account.email}</span>
              </div>
              <div className={styles.recentMeta}>
                <span className={`${styles.status} ${styles[`status${account.status}`]}`}>
                  {account.status}
                </span>
                <span className={styles.recentDate}>
                  {formatDate(account.created_at)}
                </span>
              </div>
            </div>
          ))}
          {!accountsData?.accounts.length && (
            <div className={styles.emptyState}>No accounts yet</div>
          )}
        </div>
      </div>

      <div className={styles.section}>
        <h2 className={styles.sectionTitle}>Errors by Source</h2>
        <div className={styles.chartList}>
          {errorStats?.bySource.map((item) => (
            <div key={item.source} className={styles.chartItem}>
              <span className={styles.chartLabel}>{item.source}</span>
              <div className={styles.chartBar}>
                <div
                  className={styles.chartFill}
                  style={{
                    width: `${Math.min((item.count / (errorStats.total || 1)) * 100, 100)}%`,
                  }}
                />
              </div>
              <span className={styles.chartValue}>{item.count}</span>
            </div>
          ))}
          {!errorStats?.bySource.length && (
            <div className={styles.emptyState}>No errors logged</div>
          )}
        </div>
      </div>
    </div>
  );
}
